<template>
  <div>
    <div class="ushk-flash__group J_flash_group" v-for="(data, key) in datas" :key="key" v-if="data && data.length">
      <div class="ushk-flash__date J_flash_date"><dl><dt>{{ getDay(key) }}</dt><dd>{{ getMonth(key) }}月</dd></dl></div>
      <ushk-message :did="did" v-for="item in data" :data="item" :key="item.id" @mouseenter.native="onMouseenter" @mouseleave.native="onMouseleave" @click.native="onClick" @on-remark-click="onRemarkClick"></ushk-message>
    </div>
    <remark-dialog v-model="isShowRemarkDialog" :remarkData="remarkData"/>
  </div>
</template>
<script>
  import UshkMessage from './Message'
  import RemarkDialog from './RemarkDialog'
  import { addClass, removeClass, dateFormat } from '@/commons/utils'
  import scrollMonitor from 'scrollmonitor'
  import { fetch } from "@/commons/fetch";

  let url =
  process.env.NODE_ENV === "development" ||
  window.location.href.includes("test")
    ? "https://behavior-collection-18924143967-testing.jin10.com"
    : "//log-agent.jin10.com";
  export default {
    components: {
      UshkMessage,
      RemarkDialog
    },
    props: {
      datas: {
        type: Object,
        default: {}
      }
    },
    watch: {
      datas (v) {
        this.initScrollMonitor()
      }
    },
    mounted () {
      this.getDid()
      this.initScrollMonitor()
    },
    data () {
      return {
        curImportantRelevance: '',
        oldImportantRelevance: '',
        curRelevance: '',
        relevanceActiveClassName: 'is-relevance',
        relevanceImportantClassName: 'is-relevance-important',
        isShowRemarkDialog: false,
        remarkData: {},
        did: ''
      }
    },
    methods: {
      getDid() {
        fetch({
          url: url + "/v1/did",
          type: "get",
          callback: (res) => {},
          success: (res) => {
            this.did = res.data.did
            resolve(res.data);
          },
          error: () => {},
        });
      },
      initScrollMonitor () {
        this.$nextTick(() => {
          Array.from(document.querySelectorAll('.J_flash_group')).forEach(group => {
            const $date = group.querySelector('.J_flash_date')
            const sectionWatcher = scrollMonitor.create(group)
            const sectionMinusBottomHeadline = scrollMonitor.create(group, {bottom: 0})

            sectionMinusBottomHeadline.stateChange(function () {
              if (!sectionWatcher.isInViewport) {
                removeClass($date, 'is-fixed')
                removeClass($date, 'is-bottom')
              } else if (sectionMinusBottomHeadline.isInViewport && sectionMinusBottomHeadline.isAboveViewport) {
                addClass($date, 'is-fixed')
              } else if (sectionMinusBottomHeadline.isAboveViewport) {
                addClass('is-bottom')
              } else {
                removeClass($date, 'is-fixed')
                removeClass($date, 'is-bottom')
              }
            })
          })
        })
      },
      getMonth (date) {
        return dateFormat(new Date(date.replace(/-/g, '/')), 'MM')
      },
      getDay (date) {
        return dateFormat(new Date(date.replace(/-/g, '/')), 'dd')
      },
      mouseHandle (target, isRelevanceActive) {
        const relevance = target.getAttribute('data-relevance')
        if (!relevance) {
          return false
        }
        // if (this.curImportantRelevance === relevance) {
        //   return false
        // }
        if (isRelevanceActive) {
          if (this.curRelevance === relevance) {
            clearTimeout(this.leaveTimer)
            return false
          }
          this.curRelevance = relevance
        } else {
          this.curRelevance = ''
        }
        // 由于使用数据驱动改变样式的话，会造成在有图片要点击放大时导致图片窗闪退，所以改为dom方式操作
        const $list = document.querySelector('#J_flash_list')
        try {
          var $relevances = Array.from($list.querySelectorAll(`.J_flash_item[data-relevance="${relevance}"]`))
          if ($relevances.length < 2) {
            return false
          }
          $relevances.forEach(($relevance, index) => {
            if (isRelevanceActive) {
              addClass($relevance, this.relevanceActiveClassName)
            } else {
              removeClass($relevance, this.relevanceActiveClassName)
            }
          })
        } catch (e) {
          console.log(e)
        }
      },
      onMouseenter (e) {
        this.mouseHandle(e.currentTarget, true)
      },
      onMouseleave (e) {
        const target = e.currentTarget
        if (!target.getAttribute('data-relevance')) {
          return false
        }
        this.leaveTimer = setTimeout(() => {
          this.mouseHandle(target, false)
        }, 100)
      },
      onRemarkClick (data) {
        this.isShowRemarkDialog = true
        this.remarkData = data
      },
      onClick (e) {
        const target = e.currentTarget
        const relevance = target.getAttribute('data-relevance')
        if (!relevance) {
          return false
        }
        if (!this.curImportantRelevance || this.curImportantRelevance !== relevance) {
          this.curImportantRelevance = relevance
        } else {
          this.curImportantRelevance = ''
        }
        const $list = document.querySelector('#J_flash_list')
        if (this.oldImportantRelevance && relevance !== this.oldImportantRelevance) {
          Array.from($list.querySelectorAll(`.J_flash_item[data-relevance="${this.oldImportantRelevance}"]`)).forEach(($relevance, index) => {
            removeClass($relevance, this.relevanceImportantClassName)
          })
        }
        const $relevances = Array.from($list.querySelectorAll(`.J_flash_item[data-relevance="${relevance}"]`))
        $relevances.forEach(($relevance, index) => {
          if (relevance === this.oldImportantRelevance) {
            removeClass($relevance, this.relevanceImportantClassName)
          } else {
            addClass($relevance, this.relevanceImportantClassName)
          }
        })
        this.oldImportantRelevance = this.curImportantRelevance
        this.$emit('mouseHandle', this.curImportantRelevance)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MessageGroup.vue?489953be